<template>
    <sweet-modal blocking :title="$t('modal_humanCapitalManagement_itemInfo')" ref="infoModal" class="modal">
        <div>
            <div :class="{ color: !fields.type }"  class="modal__label">
                {{$t('modal_humanCapitalManagement_scheduleType')}}: {{fields.type}}
            </div>
            <div :class="{ color: !fields.code }"  class="modal__label">
                {{$t('modal_humanCapitalManagement_hoursOrdinaryCode')}}: {{fields.code}}
            </div>
            <div :class="{ color: !fields.name }" class="modal__label">
                {{$t('modal_humanCapitalManagement_name')}}: {{fields.name}}
            </div>

            <el-row :gutter="20" style="margin-bottom: 20px;">
                <el-col :span="12">
                    <h4>{{$t('modal_humanCapitalManagement_addItemTimekeepingDetails')}}</h4>

                    <!--normal day modal start-->
                    <div v-if="fields.type === 'Normal Day'">
                        <div :class="{ color: !fields.hours }" class="modal__label">{{$t('modal_humanCapitalManagement_addItemhours')}}: {{fields.hours}}</div>
                        <div :class="{ color: !fields.someDay }" class="modal__label">{{$t('modal_humanCapitalManagement_addItemSomeDay')}}: {{fields.someDay}}</div>
                    </div>
                    <!--normal day modal ends-->

                    <!--flexi day modal start-->
                    <div v-if="fields.type === 'Flexi'">
                        <div :class="{ color: !fields.period }" class="modal__label">{{$t('modal_humanCapitalManagement_addItemPeriod')}}: {{setPeriod(fields.period, periodsList)}}</div>
                        <div :class="{ color: !fields.hoursPerPeriod }" class="modal__label">{{$t('modal_humanCapitalManagement_addItemhoursPerPeriod')}}: {{fields.hoursPerPeriod}}</div>
                        <div :class="{ color: !fields.hoursPerDay }" class="modal__label">{{$t('modal_humanCapitalManagement_addItemhoursPerDay')}}: {{fields.hoursPerDay}}</div>
                        <div :class="{ color: !fields.someDay }" class="modal__label">{{$t('modal_humanCapitalManagement_addItemSomeDay')}}: {{fields.someDay}}</div>
                    </div>
                    <!--flexi day modal ends-->

                    <!--rotation day modal start-->
                    <div v-if="fields.type === 'Rotation'">
                        <div :class="{ color: !fields.period }" class="modal__label">{{$t('modal_humanCapitalManagement_addItemPeriod')}}: {{setPeriod(fields.period, periodsList)}}</div>
                        <div :class="{ color: !fields.periodsPerCycle }" class="modal__label">{{$t('modal_humanCapitalManagement_addItemRestDaysPerCycle')}}: {{fields.periodsPerCycle}}</div>
                        <div :class="{ color: !fields.restDaysBetweenCycle }" class="modal__label">{{$t('modal_humanCapitalManagement_addItemRestDaysBetweenCycle')}}: {{fields.restDaysBetweenCycle}}</div>
                        <div :class="{ color: !fields.hoursPerPeriod }" class="modal__label">{{$t('modal_humanCapitalManagement_addItemhoursPerPeriod')}}: {{fields.hoursPerPeriod}}</div>
                        <div :class="{ color: !fields.hoursPerDay }" class="modal__label">{{$t('modal_humanCapitalManagement_addItemhoursPerDay')}}: {{fields.hoursPerDay}}</div>
                        <div :class="{ color: !fields.someDay }" class="modal__label">{{$t('modal_humanCapitalManagement_addItemSomeDay')}}: {{fields.someDay}}</div>
                    </div>
                    <!--rotation day modal ends-->
                </el-col>
                <el-col :span="12">
                    <h4>{{$t('modal_humanCapitalManagement_addItemPayrollDetails')}}</h4>

                </el-col>
            </el-row>

            <div class="modal__label">{{$t('modal_humanCapitalManagement_addItemDescription')}}: {{fields.description}}</div>
        </div>
    </sweet-modal>
</template>

<script>
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import axios from 'axios'
  export default {
    name: "ItemInfoModal",
    components: {SweetModal},
    data () {
      return {
        periodsList: [],
        fields: {
          type: null,
          code: null,
          name: null,
          description: null,
          // mormal
          hours: null,
          // flexi/rotation
          period: null,
          hoursPerPeriod: null,
          hoursPerDay: null,
          // flexi/normal/rotation
          someDay: null,
          // rotation
          periodsPerCycle: null,
          restDaysBetweenCycle: null
        }
      }
    },
    methods:{
      async openModal(row) {
        try {
          console.log(row);

          const directories = await this.directories();

          const item = await this.item(row.itemId);

          this.$refs.infoModal.open()

        } catch (err) {
          console.log(err)
        }
      },
      directories(){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.get(`/api/v1/workingHoursItem/directories?companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log('response', response.data);
              this.periodsList = response.data.directories.periods;
              loader.hide();
              resolve(response.data)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide();
              reject(error)
            });
        })
      },
      item(itemId){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.get(`/api/v1/workingHoursItem/item?companyId=${this.$route.query.companyId}&itemId=${itemId}`)
            .then(response => {
              console.log('response', response.data);
              this.fields.type = response.data.fields.fields.type;
              this.fields.code = response.data.fields.fields.code;
              this.fields.name = response.data.fields.fields.name;
              this.fields.description = response.data.fields.fields.description;
              // normal
              this.fields.hours = response.data.fields.fields.hours;
              // flexi/rotation
              this.fields.period = response.data.fields.fields.period;
              this.fields.hoursPerPeriod = response.data.fields.fields.hoursPerPeriod;
              this.fields.hoursPerDay = response.data.fields.fields.hoursPerDay;
              // flexi/normal/rotation
              this.fields.someDay = response.data.fields.fields.someDay;
              // rotation
              this.fields.periodsPerCycle = response.data.fields.fields.periodsPerCycle;
              this.fields.restDaysBetweenCycle = response.data.fields.fields.restDaysBetweenCycle;
              loader.hide();
              resolve(response.data.item)
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide();
              reject(error)
            });
        })
      },
      setPeriod(id, list) {
        return list.filter(val => val.id === id)[0].name
      }
    }
  }
</script>

<style scoped>
    .color {
        color: #ccc;
    }
</style>
